// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"17b79106","818":"cc85ae56"}[chunkId] + ".chunk.js";
};